import {Component} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {TranslateService} from "app/translate/translate.service";
import {FilterFormService} from "app/views/filter_form/filter_form.service";
import {EventsService} from "app/lib/EventsService";
import {BaseComponent} from "app/views/base.component";
import {ModalService} from "../../views/modal/base_modal.component";
import {ErrorsDetailsComponent} from "./details/errors_details.component";
import {DateFormat} from "../../pipes/dateFormat.pipe";
import {ChartParams} from "../../views/chart/chart.component";
import {FilterParams} from "../../models/filter_form.model";

import { BillingService2 } from "../billing.service";
import { mergeFilterParams } from "../../lib/lib";

@Component({
	selector: 'errors',
	templateUrl: './errors.component.html',
	providers:[DateFormat]
})
export class ErrorsComponent extends BaseComponent {
	rows = [];

	items = [];

	listLoader = false;

	page = 1;

	pageSize = 100;

	paidErrorChart = new ChartParams();
	processingFilterChart = new ChartParams();
	noMoneyOrExpirerChart = new ChartParams();
	rejectEmitterChart = new ChartParams();
	error3dsChart = new ChartParams();
	unknownChart = new ChartParams();
	notClassifiedChart = new ChartParams();
	errSiteUserManualRecurentChart = new ChartParams();
	invalidCardDataChart = new ChartParams();

	constructor(
		public service2: BillingService2,
		public activatedRoute: ActivatedRoute,
		public translate: TranslateService,
		public filter: FilterFormService,
		public eventsService: EventsService,
		public modalService: ModalService,
		private dateFormat: DateFormat
	) {
		super(eventsService, service2, activatedRoute, filter, translate);

		this.paidErrorChart.setOptions({
			title: 'График ошибок',
			names: {
				'processingFilter': this.translate.__A('billing.errors.processingFilter'),
				'noMoneyOrExpirer': this.translate.__A('billing.errors.noMoneyOrExpirer'),
				'rejectEmitter': this.translate.__A('billing.errors.rejectEmitter'),
				'error3ds': this.translate.__A('billing.errors.error3ds'),
				'unknown': this.translate.__A('billing.errors.unknown'),
				'notClassified': this.translate.__A('billing.errors.notClassified'),
				'invalidCardData': this.translate.__A('billing.errors.invalidCardData'),
			},
			axis: {
				y: {
					label: {
						text: 'Пользователи',
						position: 'outer-middle'
					}
				},
			}
		});
		
		this.processingFilterChart.setOptions({
			title: this.translate.__A('billing.errors.processingFilter'),
			axis: {
				y: {
					label: {
						text: 'Пользователи',
						position: 'outer-middle'
					}
				},
			}
		});
		
		this.noMoneyOrExpirerChart.setOptions({
			title: this.translate.__A('billing.errors.noMoneyOrExpirer'),
			axis: {
				y: {
					label: {
						text: 'Пользователи',
						position: 'outer-middle'
					}
				},
			}
		});
		
		this.rejectEmitterChart.setOptions({
			title: this.translate.__A('billing.errors.rejectEmitter'),
			axis: {
				y: {
					label: {
						text: 'Пользователи',
						position: 'outer-middle'
					}
				},
			}
		});
		
		this.error3dsChart.setOptions({
			title: this.translate.__A('billing.errors.error3ds'),
			axis: {
				y: {
					label: {
						text: 'Пользователи',
						position: 'outer-middle'
					}
				},
			}
		});
		
		this.unknownChart.setOptions({
			title: this.translate.__A('billing.errors.unknown'),
			names: {
				'UNKNOWN_ERROR': this.translate.__A('billing.errors.UNKNOWN_ERROR')
			},
			axis: {
				y: {
					label: {
						text: 'Пользователи',
						position: 'outer-middle'
					}
				},
			}
		});

		this.notClassifiedChart.setOptions({
			title: 'Неклассифицированные ошибки',
			axis: {
				y: {
					label: {
						text: 'Пользователи',
						position: 'outer-middle'
					}
				},
			}
		});

		this.errSiteUserManualRecurentChart.setOptions({
			title: 'Пользователи и Сайты',
			axes: {
				userCountRecurent: 'y',
				siteCountRecurent: 'y',
				userCountManual: 'y2',
				siteCountManual: 'y2',
			},
			axis: {
				y: {
					label: {
						text: 'Рекурентные',
						position: 'outer-middle'
					}
				},
				y2: {
					show: true,
					label: {
						text: 'Ручные',
						position: 'outer-middle'
					}
				}
			}
		});

		this.invalidCardDataChart.setOptions({
			title: 'Неверные данные карты',
			axis: {
				y: {
					label: {
						text: 'Пользователи',
						position: 'outer-middle'
					}
				},
			}
		});
	}
	
	
	async getData() {
		await this.getPaidErrorChart();

		await this.getList();
	}
	
	
	async getList(params?: FilterParams) {
		this.listLoader = true;
		
		const { stats } = await this.service2.error.stats(
			mergeFilterParams(
				this.filter.filterParams,
				params
			)
		).toPromise();
		this.items = stats;
		
		this.listLoader = false;
		
		await this.getPage();
	}
	
	
	async getPage() {
		let s = (this.page - 1) * this.pageSize;
		let e = s + this.pageSize;
		this.rows = this.items.slice(s, e);
	}
	
	async showDetails(timestamp: string, type: string) {
		const modalRef = this.modalService.open(
			ErrorsDetailsComponent,
			{
				title: this.dateFormat.transform(timestamp, 'DD.MM.YYYY'),
				type: type
			},
			{size: type === 'sites' ? 'hg' : 'lg'}
			);
		
		const { stats }  = await this.service2.error.detail(
			mergeFilterParams(
				this.filter.filterParams,
				<FilterParams>{timestamp, type}
			)
		).toPromise();
		modalRef.componentInstance.details = stats;
	}
	
	
	async getPaidErrorChart(params?: FilterParams) {
		const me = this;
		
		if (me.dontLoad.paidChart) {
			return true;
		}
		
		const chartSubTypes = [
			'paidError', 'error3ds', 'processingFilter',
			'noMoneyOrExpirer', 'rejectEmitter', 'unknown',
			'notClassified', 'errSiteUserManualRecurent', 'invalidCardData',
		];
		
		for (const chartSubType of chartSubTypes) {
			const chart = me[`${chartSubType}Chart`];
			const fp = mergeFilterParams(
				this.filter.filterParams,
				params,
				chartSubType === 'paidError' ? {} : <FilterParams>{ chartSubType, }
			);
			
			chart.showLoader();
			const { charts } = await me.service2.error.chart(fp).toPromise();
			chart.data = charts;
			chart.hideLoader();
		}
	}
}
